module.exports = __webpack_public_path__ + "media/static/icons/icon-thumbs-down-solid-c61fc5dad4f95a2f1ede83a84d372220.svg";